import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Status of Space Survey',
    name: 'Space Survey Status',
    partialId: PartialId.Standard.create('space_survey_status'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
